module.exports = __webpack_public_path__ + "img/glass-shoe_mobile.4663707b.png";